import { render, staticRenderFns } from "./SearchSpecialist.vue?vue&type=template&id=483ebef3"
import script from "./SearchSpecialist.vue?vue&type=script&lang=js"
export * from "./SearchSpecialist.vue?vue&type=script&lang=js"
import style0 from "./SearchSpecialist.vue?vue&type=style&index=0&id=483ebef3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports